import { Customer } from '@/types/storefront';
import { create } from 'zustand';

export const useCustomerStore = create<{
  customer?: Customer;
}>(() => ({
  customer: undefined
}));
